import { useState, createContext, useReducer } from 'react'
import { isMobile } from 'react-device-detect'
import { cloneDeep } from 'lodash'
import {
  sessionsNumberOfItemsPerPage,
  boardsNumberOfItemsPerPage,
  sailsNumberOfItemsPerPage,
} from '../assets/colors'
import { noAccount } from '../assets/accounts'

export const MobileContext = createContext()

export const MobileProvider = ({ children }) => {
  // const is_mobile =
  //   navigator.userAgent.includes('Mobile') ||
  //   navigator.userAgent.includes('mobile')

  const [mobile, setMobile] = useState(isMobile)

  return (
    <MobileContext.Provider value={{ mobile, setMobile }}>
      {children}
    </MobileContext.Provider>
  )
}

export const LangContext = createContext()

export const LangProvider = ({ children }) => {
  const language = navigator.language === 'fr-FR' ? 'fr' : 'eng'
  const [lang, setLang] = useState(language)
  const toggleLang = () => {
    setLang(lang === 'fr' ? 'eng' : 'fr')
  }

  return (
    <LangContext.Provider value={{ lang, toggleLang }}>
      {children}
    </LangContext.Provider>
  )
}

export const RestrictedContext = createContext()

export const RestrictedProvider = ({ children }) => {
  const [restricted, setRestricted] = useState(true)
  const toggleRestricted = () => {
    setRestricted(!restricted)
  }

  return (
    <RestrictedContext.Provider value={{ restricted, toggleRestricted }}>
      {children}
    </RestrictedContext.Provider>
  )
}

export const UserContext = createContext()

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    userName: '',
    userId: -1,
    accountType: noAccount,
    subscribeStart: null,
    subscribeEnd: null,
    subscribeLength: null,
  })
  const changeUser = (new_user) => {
    setUser(new_user)
  }

  return (
    <UserContext.Provider value={{ user, changeUser }}>
      {children}
    </UserContext.Provider>
  )
}

export const SessionWSContext = createContext()

export const SessionWSProvider = ({ children }) => {
  const [sessionWS, setSessionWS] = useState(null)
  const changeSessionWS = (new_session) => {
    setSessionWS(new_session)
  }

  return (
    <SessionWSContext.Provider value={{ sessionWS, changeSessionWS }}>
      {children}
    </SessionWSContext.Provider>
  )
}

export const ListSessionsWSContext = createContext()

export const ListSessionsWSProvider = ({ children }) => {
  const sessionsReducer = (state, action) => {
    const numberOfItemsPerPage = 10
    switch (action.type) {
      case 'RESET_SESSIONS':
        return {
          initialData: [],
          data: [],
          listSessionsPage: [],
          isLoading: false,
          isError: false,
          selectedPage: 1,
          totalItems: 0,
          sortOrder: { sortType: 'NONE', isReverse: true },
          searchInput: '',
        }
      case 'SESSIONS_FETCH_INIT':
        return { ...state, isLoading: true, isError: false }
      case 'SESSIONS_FETCH_OK':
        return {
          ...state,
          initialData: cloneDeep(action.payload),
          data: cloneDeep(action.payload),
          listSessionsPage: cloneDeep(
            action.payload.slice(0, numberOfItemsPerPage)
          ),
          isLoading: false,
          isError: false,
          totalItems: action.payload.length,
          sortOrder: { sortType: 'DATE_SORT', isReverse: true },
        }
      case 'SESSIONS_FETCH_FAILED':
        return { ...state, isLoading: false, isError: true }
      case 'REMOVE_SESSION':
        return {
          ...state,
          initialData: cloneDeep(action.payload),
          data: cloneDeep(action.payload),
          listSessionsPage: cloneDeep(
            action.payload.slice(
              (state.selectedPage - 1) * sessionsNumberOfItemsPerPage,
              state.selectedPage * sessionsNumberOfItemsPerPage
            )
          ),
          totalItems: action.payload.length,
          searchInput: '',
        }
      case 'NEW_PAGE':
        return {
          ...state,
          listSessionsPage: cloneDeep(
            state.data.slice(
              (action.payload - 1) * sessionsNumberOfItemsPerPage,
              action.payload * sessionsNumberOfItemsPerPage
            )
          ),
          selectedPage: action.payload,
        }
      case 'NEW_ITEM_SELECTED':
        return {
          ...state,
          data: cloneDeep(action.payload),
          listSessionsPage: cloneDeep(
            action.payload.slice(
              (state.selectedPage - 1) * sessionsNumberOfItemsPerPage,
              state.selectedPage * sessionsNumberOfItemsPerPage
            )
          ),
          totalItems: action.payload.length,
        }
      case 'ADD_SESSION':
        return {
          ...state,
          initialData: cloneDeep(action.payload),
          data: cloneDeep(action.payload),
          listSessionsPage: cloneDeep(action.payload.slice(0, 10)),
          selectedPage: 1,
          totalItems: action.payload.length,
        }
      case 'ADD_VIDEO_FILE_TO_SESSION':
      case 'CHANGED_SESSION_TITLE':
      case 'CHANGED_SESSION_RESTR':
      case 'CHANGED_METEO_DATA':
        return {
          ...state,
          initialData: cloneDeep(action.payload),
          data: cloneDeep(action.payload),
          listSessionsPage: cloneDeep(
            action.payload.slice(
              (state.selectedPage - 1) * sessionsNumberOfItemsPerPage,
              state.selectedPage * sessionsNumberOfItemsPerPage
            )
          ),
        }
      case 'SORT_CHANGED':
        return {
          ...state,
          data: cloneDeep(action.payload.list),
          listSessionsPage: cloneDeep(
            action.payload.list.slice(
              (state.selectedPage - 1) * sessionsNumberOfItemsPerPage,
              state.selectedPage * sessionsNumberOfItemsPerPage
            )
          ),
          sortOrder: action.payload.sort,
        }
      case 'RESTR_CHANGED':
        return { ...state, sortOrder: { sortType: 'NONE', isReverse: false } }
      case 'SEARCH':
        return {
          ...state,
          data: [...action.payload.data],
          listSessionsPage: cloneDeep(
            action.payload.data.slice(0, sessionsNumberOfItemsPerPage)
          ),
          selectedPage: 1,
          totalItems: action.payload.data.length,
          sortOrder: { sortType: 'NONE', isReverse: false },
          searchInput: action.payload.searchValue,
        }
      default:
        throw new Error()
    }
  }

  const [listSessionsWS, setListSessionsWS] = useReducer(sessionsReducer, {
    initialData: [],
    data: [],
    listSessionsPage: [],
    isLoading: false,
    isError: false,
    selectedPage: 1,
    totalItems: 0,
    sortOrder: { sortType: 'NONE', isReverse: true },
    searchInput: '',
  })

  return (
    <ListSessionsWSContext.Provider
      value={{ listSessionsWS, setListSessionsWS }}
    >
      {children}
    </ListSessionsWSContext.Provider>
  )
}

export const ListBoardsContext = createContext()

export const ListBoardsProvider = ({ children }) => {
  const boardsReducer = (state, action) => {
    switch (action.type) {
      case 'RESET_BOARDS':
        return {
          initialData: [],
          data: [],
          listBoardsPage: [],
          isLoading: false,
          isError: false,
          selectedPage: 1,
          totalItems: 0,
          sortOrder: { sortType: 'NONE', isReverse: true },
          searchInput: '',
        }
      case 'BOARDS_FETCH_INIT':
        return { ...state, isLoading: true, isError: false }
      case 'NEW_PAGE':
        return {
          ...state,
          listBoardsPage: cloneDeep(
            state.data.slice(
              (action.payload - 1) * boardsNumberOfItemsPerPage,
              action.payload * boardsNumberOfItemsPerPage
            )
          ),
          selectedPage: action.payload,
        }
      case 'NEW_ITEM_SELECTED':
        return {
          ...state,
          data: cloneDeep(action.payload),
          listBoardsPage: cloneDeep(
            action.payload.slice(
              (state.selectedPage - 1) * boardsNumberOfItemsPerPage,
              state.selectedPage * boardsNumberOfItemsPerPage
            )
          ),
          totalItems: action.payload.length,
        }
      case 'ADD_BOARD':
        return {
          ...state,
          initialData: cloneDeep(action.payload),
          data: cloneDeep(action.payload),
          listBoardsPage: cloneDeep(
            action.payload.slice(0, boardsNumberOfItemsPerPage)
          ),
          selectedPage: 1,
          totalItems: action.payload.length,
        }
      case 'UPDATE_BOARD':
        return {
          ...state,
          initialData: cloneDeep(action.payload),
          data: cloneDeep(action.payload),
          listBoardsPage: cloneDeep(
            action.payload.slice(
              (state.selectedPage - 1) * boardsNumberOfItemsPerPage,
              state.selectedPage * boardsNumberOfItemsPerPage
            )
          ),
        }
      case 'REMOVE_BOARD':
        return {
          ...state,
          initialData: cloneDeep(action.payload),
          data: cloneDeep(action.payload),
          listBoardsPage: cloneDeep(
            action.payload.slice(
              (state.selectedPage - 1) * boardsNumberOfItemsPerPage,
              state.selectedPage * boardsNumberOfItemsPerPage
            )
          ),
          totalItems: action.payload.length,
        }
      case 'BOARDS_FETCH_OK':
        return {
          ...state,
          initialData: cloneDeep(action.payload),
          data: cloneDeep(action.payload),
          listBoardsPage: cloneDeep(
            action.payload.slice(0, boardsNumberOfItemsPerPage)
          ),
          isLoading: false,
          isError: false,
          totalItems: action.payload.length,
          sortOrder: { sortType: 'NONE', isReverse: false },
        }
      case 'BOARDS_FETCH_FAILED':
        return { ...state, isLoading: false, isError: true }
      case 'SORT_CHANGED':
        return {
          ...state,
          data: cloneDeep(action.payload.list),
          listBoardsPage: cloneDeep(
            action.payload.list.slice(
              (state.selectedPage - 1) * boardsNumberOfItemsPerPage,
              state.selectedPage * boardsNumberOfItemsPerPage
            )
          ),
          sortOrder: action.payload.sort,
        }
      case 'SEARCH':
        return {
          ...state,
          data: [...action.payload.data],
          listBoardsPage: cloneDeep(
            action.payload.data.slice(0, boardsNumberOfItemsPerPage)
          ),
          selectedPage: 1,
          totalItems: action.payload.data.length,
          sortOrder: { sortType: 'NONE', isReverse: false },
          searchInput: action.payload.searchValue,
        }
      default:
        throw new Error()
    }
  }

  const [listBoards, setListBoards] = useReducer(boardsReducer, {
    initialData: [],
    data: [],
    listBoardsPage: [],
    isLoading: false,
    isError: false,
    selectedPage: 1,
    totalItems: 0,
    sortOrder: { sortType: 'NONE', isReverse: false },
    searchInput: '',
  })

  return (
    <ListBoardsContext.Provider value={{ listBoards, setListBoards }}>
      {children}
    </ListBoardsContext.Provider>
  )
}

export const ListSailsContext = createContext()

export const ListSailsProvider = ({ children }) => {
  const sailsReducer = (state, action) => {
    switch (action.type) {
      case 'RESET_SAILS':
        return {
          initialData: [],
          data: [],
          listSailsPage: [],
          isLoading: false,
          isError: false,
          selectedPage: 1,
          totalItems: 0,
          sortOrder: { sortType: 'NONE', isReverse: true },
          searchInput: '',
        }
      case 'SAILS_FETCH_INIT':
        return { ...state, isLoading: true, isError: false }
      case 'NEW_PAGE':
        return {
          ...state,
          listSailsPage: cloneDeep(
            state.data.slice(
              (action.payload - 1) * sailsNumberOfItemsPerPage,
              action.payload * sailsNumberOfItemsPerPage
            )
          ),
          selectedPage: action.payload,
        }
      case 'NEW_ITEM_SELECTED':
        return {
          ...state,
          data: cloneDeep(action.payload),
          listSailsPage: cloneDeep(
            action.payload.slice(
              (state.selectedPage - 1) * sailsNumberOfItemsPerPage,
              state.selectedPage * sailsNumberOfItemsPerPage
            )
          ),
          totalItems: action.payload.length,
        }
      case 'ADD_SAIL':
        return {
          ...state,
          initialData: cloneDeep(action.payload),
          data: cloneDeep(action.payload),
          listSailsPage: cloneDeep(
            action.payload.slice(0, sailsNumberOfItemsPerPage)
          ),
          selectedPage: 1,
          totalItems: action.payload.length,
        }
      case 'UPDATE_SAIL':
        return {
          ...state,
          initialData: cloneDeep(action.payload),
          data: cloneDeep(action.payload),
          listSailsPage: cloneDeep(
            action.payload.slice(
              (state.selectedPage - 1) * sailsNumberOfItemsPerPage,
              state.selectedPage * sailsNumberOfItemsPerPage
            )
          ),
        }
      case 'REMOVE_SAIL':
        return {
          ...state,
          initialData: cloneDeep(action.payload),
          data: cloneDeep(action.payload),
          listSailsPage: cloneDeep(
            action.payload.slice(
              (state.selectedPage - 1) * sailsNumberOfItemsPerPage,
              state.selectedPage * sailsNumberOfItemsPerPage
            )
          ),
          totalItems: action.payload.length,
        }
      case 'SAILS_FETCH_OK':
        return {
          ...state,
          initialData: cloneDeep(action.payload),
          data: cloneDeep(action.payload),
          listSailsPage: cloneDeep(
            action.payload.slice(0, sailsNumberOfItemsPerPage)
          ),
          isLoading: false,
          isError: false,
          totalItems: action.payload.length,
          sortOrder: { sortType: 'NONE', isReverse: false },
        }
      case 'SAILS_FETCH_FAILED':
        return { ...state, isLoading: false, isError: true }
      case 'SORT_CHANGED':
        return {
          ...state,
          data: cloneDeep(action.payload.list),
          listSailsPage: cloneDeep(
            action.payload.list.slice(
              (state.selectedPage - 1) * sailsNumberOfItemsPerPage,
              state.selectedPage * sailsNumberOfItemsPerPage
            )
          ),
          sortOrder: action.payload.sort,
        }
      case 'SEARCH':
        return {
          ...state,
          data: [...action.payload.data],
          listSailsPage: cloneDeep(
            action.payload.data.slice(0, sailsNumberOfItemsPerPage)
          ),
          selectedPage: 1,
          totalItems: action.payload.data.length,
          sortOrder: { sortType: 'NONE', isReverse: false },
          searchInput: action.payload.searchValue,
        }
      default:
        throw new Error()
    }
  }

  const [listSails, setListSails] = useReducer(sailsReducer, {
    initialData: [],
    data: [],
    listSailsPage: [],
    isLoading: false,
    isError: false,
    selectedPage: 1,
    totalItems: 0,
    sortOrder: { sortType: 'NONE', isReverse: false },
    searchInput: '',
  })

  return (
    <ListSailsContext.Provider value={{ listSails, setListSails }}>
      {children}
    </ListSailsContext.Provider>
  )
}

export const TrkptsWSContext = createContext()

export const TrkptsWSProvider = ({ children }) => {
  const [trkptsWS, setTrkptsWS] = useState({
    brut: [],
    origin: '',
  })
  const changeTrkptsWS = (new_trkpts) => {
    setTrkptsWS(new_trkpts)
  }

  return (
    <TrkptsWSContext.Provider value={{ trkptsWS, changeTrkptsWS }}>
      {children}
    </TrkptsWSContext.Provider>
  )
}
